import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardProductosComponent } from './card-productos/card-productos.component';
import { CardProductosTwoComponent } from './card-productos-two/card-productos-two.component';
import { MessageCardComponent } from '../components/message-card/message-card.component';
import { ContainerCardProductComponent } from '../components/container-card-product/container-card-product.component';
import { IonicModule } from '@ionic/angular';
import { PipeModule } from '../pipes/pipe-module.module';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { PictureComponent } from '../components/picture/picture.component';
import { ContainerCardSubscriptionComponent } from '../components/container-card-subscription/container-card-subscription.component';

const declarations = [
  CardProductosComponent,
  CardProductosTwoComponent,
  MessageCardComponent,
  ContainerCardProductComponent,
  ContainerCardSubscriptionComponent,
  PictureComponent,
];

@NgModule({
  declarations,
  imports: [
    CommonModule,
    IonicModule,
    PipeModule,
    TranslateModule,
    RouterModule,
  ],
  exports: declarations,
})
export class ProductsComponentModule {}
